import { ToastContext } from './ToastContext'

export default ToastContext
